<template>
  <div class="page__crawl-keyword a-page">
    <div style="background-color:white; padding:10px; border-radius: 4px; overflow: hidden">
      <el-tabs v-model="tab">
        <el-tab-pane :label="$t('tool.shopee_trend')" name="second"></el-tab-pane>
      </el-tabs>

      <template v-if="tab=== 'second'">
        <br>
        <el-row>
          <el-col :sm="20">
            <el-input type="text" size="mini" style="width: 30%" :placeholder="$t('tool.input_keyword')"
                      v-model="keyword_tracking" @keyup.enter.native="m__enter_input_keyword_tracking"></el-input>
            &nbsp;
            <el-button type="primary" size="mini" icon="el-icon-plus" :loading="loading.tracking_add_keyword"
                       @click="m__add_keyword_tracking">{{ $t('keyword.add_keywords') }}
            </el-button>
            <el-button type="info" size="mini" icon="el-icon-upload" :loading="loading.tracking_add_keyword"
                       @click="m__choose_excel_file">{{ $t('base.import_from_excel') }}
            </el-button>
            <el-button type="info" size="mini" icon="el-icon-download" @click="m__tracking_download_excel">
              {{ $t('base.download_x_file', {x: $t('base.keywords')}) }}
            </el-button>
            <el-button v-if="$store.state.userInfo.username === 'vuducminhdev07'" type="danger" size="mini"
                       icon="el-icon-delete" @click="m__multiple_delete_keyword_tracking">
              {{ $t('base.mass_delete') }}
            </el-button>
          </el-col>
          <el-col :sm="4">
            <el-input size="mini" :placeholder="$t('input.placeholder')" v-model="tracking_search_keyword"></el-input>
          </el-col>
        </el-row>

        <div style="margin-top: 20px; margin-bottom: 10px">
          <strong style="font-size: 13px">{{ $t('tool.added_keywords') }}:</strong>
          <strong style="font-size: 13px"
                  :class="keyword_tracking_list.length < limit_keywords ? 'text-success' : 'text-danger'">{{
              keyword_tracking_list.length
            }}</strong>/<strong style="font-size: 13px" class="text-danger">{{ limit_keywords }}</strong>
        </div>

        <div>
          <el-table :data="c__show_keyword_tracking_display_list">
            <el-table-column label="#" width="50px">
              <template slot="header" slot-scope="scope">
                <el-checkbox size="mini" :indeterminate="indeterminate" v-model="is_selected_all"
                             @change="m__select_all"></el-checkbox>
              </template>
              <template slot-scope="scope">
                <el-checkbox size="mini" v-model="scope.row.checked" @change="m__indeterminate"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.keyword')" prop="keyword"></el-table-column>
            <el-table-column :label="$t('base.created_at')" width="400px">
              <template slot-scope="scope">
                {{ scope.row.createdAt | moment('DD-MM-YYYY HH:mm') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.optional')" width="200px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__get_keyword_tracking_volume(scope.row)"
                           :loading="scope.row.loading">
                  <strong class="text-primary">{{ $t('base.see_data') }}</strong>
                </el-button>
                <el-button v-if="$store.state.userInfo.username === 'vuducminhdev07'" type="text" size="mini"
                           @click="m__delete_keyword_tracking(scope.row)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :current-page.sync="tracking_filter.current_page"
                         :page-size="tracking_filter.page_size"
                         layout="prev, pager, next, total" :total="c__show_keyword_tracking_filter_list.length"/>
        </div>
      </template>
    </div>

    <el-dialog :visible.sync="show_dialog.filter" :close-on-click-modal="false" width="600px">
      <div slot="title" style="padding:10px">
        <el-table :data="filter">
          <el-table-column :label="$t('base.column')" prop="label">
            <template slot-scope="scope">
              <span style="font-weight: 700" :class="scope.row.value ? 'text-success' : ''">{{ scope.row.label }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.expression')" prop="expression" width="100px">
            <template slot-scope="scope">
              <el-select class="full-w" size="mini" v-model="scope.row.expression">
                <el-option label=">" value=">"></el-option>
                <el-option label="<" value="<"></el-option>
                <el-option label="=" value="==="></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.value')" prop="value" width="120px">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.value" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.optional')" width="100px" align="right">
            <template slot-scope="scope">
              <div style="height: 3px"></div>
              <el-button size="mini" type="danger"
                         @click="() => {scope.row.value = null; scope.row.expression = '>'}">Reset
              </el-button>
              <div style="height: 3px"></div>
            </template>
          </el-table-column>
        </el-table>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="m__delete_filter">
            {{ $t('base.delete_filter') }}
          </el-button>
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__start_filter">{{
              $t('base.execute')
            }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.volume" :close-on-click-modal="false" width="95%">
      <div slot="title" style="padding:10px">
        <span style="font-size: 15px">{{ $t('tool.shopee_trend_data') }}: </span> <strong
        style="font-size: 15px" class="text-warning">{{ tracking_selected_keyword }}</strong>
        <br>
        <br>

        <div style="display: flex; gap: 10px">
          <div style="flex: 1;">
            <el-tabs v-model="tracking_tab">
              <el-tab-pane :label="$t('base.chart')" name="chart">
              </el-tab-pane>
              <el-tab-pane :label="$t('base.table')" name="table">
              </el-tab-pane>
            </el-tabs>
          </div>
          <div style="flex: 0; white-space: nowrap;">
            <el-button size="mini" icon="el-icon-download" @click="m__export_data()">
              {{ $t('base.export_data') }}
            </el-button>
          </div>
        </div>

        <CrawlLineChart v-if="tracking_tab === 'chart'" style="margin-top: 30px; height: 300px"
                        :volume_data="chart_tracking_volume"></CrawlLineChart>

        <el-table v-show="tracking_tab === 'table'" :data="keyword_tracking_volume" ref="volume_table_view">
          <el-table-column :label="$t('base.updated_at')" prop="createdAt">
            <template slot-scope="scope">{{ scope.row.createdAt | moment('DD-MM-YYYY') }}</template>
          </el-table-column>
          <el-table-column :label="$t('base.volume')" prop="volume" sortable>
            <template slot-scope="scope">{{ scope.row.volume | currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('base.relevance')" prop="relevance" sortable></el-table-column>
          <el-table-column :label="$t('base.recommend_price')" prop="recommendPrice" sortable>
            <template slot-scope="scope">{{ scope.row.recommendPrice | currency }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" type="file"
           @change="m__import_excel_file" id="input_control" style="display: none;">
  </div>
</template>

<script>
import {drop as _drop, orderBy as _orderBy, take as _take} from 'lodash'
import component__keyword_file_manager from '../keyword/component__keyword_file_manager.vue'
import readXlsxFile from 'read-excel-file'
import CrawlLineChart from './crawl_line_chartjs'
import {check_channel, check_feature, show_expr_notification} from '../../addon/check_license'
import {fix_ads_mixins} from "../../mixins/fix_ads";

export default {
  name: 'page__crawl-keyword',

  mixins: [fix_ads_mixins],

  components: {
    component__keyword_file_manager,
    CrawlLineChart
  },

  data() {
    return {
      sort_option: {
        order: null,
        prop: null
      },
      tab: 'second',
      keyword_filter: {
        pages: [10, 20, 30, 40, 50, 100],
        page_size: 20,
        current_page: 0
      },
      tracking_filter: {
        pages: [10, 20, 30, 40, 50, 100],
        page_size: 20,
        current_page: 0
      },
      search_keyword: '',
      keyword: '',
      keyword_list: [],
      selected_keyword: [],
      set_exists: new Set(),
      set_queue: new Set(),
      max_keyword: null,
      loading: {
        get_keyword: false,
        download_excel: false,
        download_csv: false,
        tracking_get_keyword: false,
        tracking_add_keyword: false
      },
      is_deleted: false,
      fff_tab: 2,
      fff_tool: false,
      keyword_manager: {
        show: false
      },
      change_price: {
        show: false,
        apply_field: 'sp_price',
        type: 'PERCENT',
        func: 'SUB',
        percent: 20,
        value: 1000
      },
      save_keyword_file: {
        show: false,
        loading: false,
        filename: 'Tệp keyword'
      },
      show_dialog: {
        filter: false,
        volume: false
      },
      filter: [
        {
          label: this.$t('base.relevance'),
          key: 'relevance',
          camel_key: 'relevance',
          checked: true,
          expression: '>',
          value: null,
          is_percent: false
        },
        {
          label: this.$t('base.volume'),
          key: 'search_volume',
          camel_key: 'search_volume',
          checked: true,
          expression: '>',
          value: null,
          is_percent: false
        },
        {
          label: this.$t('base.shopee_recommend_price'),
          key: 'recommend_price',
          camel_key: 'recommend_price',
          checked: true,
          expression: '>',
          value: null,
          is_percent: false
        }
      ],
      filter_clone: null,
      keyword_tracking: '',
      keyword_tracking_list: [],
      keyword_tracking_volume: [],
      chart_tracking_volume: [],
      indeterminate: false,
      is_selected_all: false,
      tracking_selected_keyword: '',
      tracking_search_keyword: '',
      tracking_tab: 'chart',
      limit_keywords: 100,
      // todo: fake data
      shop: {extra_data: {country: 'vn'}}
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_channel(['shopee_marketing_survey', 'shopee_analysis_spoiler']) || check_feature('spoil_ads') || check_feature('shopee_trend')) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  beforeDestroy() {
    this.is_deleted = true
  },

  async beforeMount() {
    if (['ads.atosa14@gmail.com'].includes(this.$store.state.userInfo.username)) {
      this.limit_keywords = 500
    }

    await this.m__get_keyword_tracking()
  },

  computed: {
    c__show_keyword_filter_list() {
      let result = this.keyword_list

      if (this.filter_clone) {
        for (const item of this.filter_clone) {
          if (item.value) {
            result = result.filter(i => eval(`${i[item.camel_key]}${item.expression}${item.value}`))
          }
        }
      }

      if (this.sort_option.order) {
        this.sort_option.order === 'ascending' && (result = _orderBy(result, [this.sort_option.prop], ['asc']))
        this.sort_option.order === 'descending' && (result = _orderBy(result, [this.sort_option.prop], ['desc']))
      }

      // let keyword = this.remove_unicode(this.search_keyword).trim()
      return result.filter(e => e.keyword.normalize('NFC').includes(this.search_keyword.trim().normalize('NFC')))
    },

    c__show_keyword_display_list() {
      const limit = this.keyword_filter.page_size
      const skip = limit * (this.keyword_filter.current_page - 1)
      return _take(_drop(this.c__show_keyword_filter_list, skip), limit)
    },

    c__show_keyword_tracking_filter_list() {
      let result = this.keyword_tracking_list
      return result.filter(e => e.keyword.normalize('NFC').includes(this.tracking_search_keyword.trim().normalize('NFC')))
    },

    c__show_keyword_tracking_display_list() {
      const limit = this.tracking_filter.page_size
      const skip = limit * (this.tracking_filter.current_page - 1)
      return _take(_drop(this.c__show_keyword_tracking_filter_list, skip), limit)
    }
  },

  methods: {
    async m__export_data() {
      if (!this.keyword_tracking_volume.length) return

      const column_labels = this.$refs.volume_table_view.columns.map(i => i.label)
      console.log('column_labels', column_labels)
      const data = []

      for (const row of this.keyword_tracking_volume) {
        const item = []
        for (const col of this.$refs.volume_table_view.columns) {
          if (col.property === 'createdAt') {
            item.push(this.dayjs(new Date(row.createdAt)).format('DD/MM/YYYY HH:mm'))
          } else {
            item.push(+row[col.property])
          }
        }
        data.push(item)
      }

      const filename = `keyword-volume-${this.tracking_selected_keyword}.xlsx`
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        filename,
        data: [column_labels, ...data]
      }, {
        ...this.cf(),
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    m__start_filter() {
      let any_change = false
      for (const item of this.filter) {
        if (item.value) {
          any_change = true
          break
        }
      }
      if (!any_change) {
        this.filter_clone = null
      } else {
        this.filter_clone = JSON.parse(JSON.stringify(this.filter))
      }
      this.show_dialog.filter = false
    },

    m__delete_filter() {
      this.filter.forEach(i => {
        i.value = null
        i.expression = '>'
      })
      this.filter_clone = null
      this.show_dialog.filter = false
    },

    m__show_filter_dialog() {
      this.show_dialog.filter = true
    },

    m__sort_change({
                     prop,
                     order
                   }) {
      this.sort_option.order = order
      this.sort_option.prop = prop
    },

    m__sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    async m__enter_input() {
      if (!this.loading.get_keyword) {
        await this.m__get_keyword()
      }
    },

    async m__get_keyword() {
      if (!this.keyword) {
        return
      }

      try {
        this.loading.get_keyword = true

        this.keyword_list = []
        this.set_exists = new Set()
        this.set_queue = new Set()

        const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword/get_keyword', {keyword: this.keyword}, this.cf())

        for (const keyword of resp.body.data) {
          keyword.checked = false
          keyword.added = false
          keyword.recommend_price = this.m__calculate(keyword.recommend_price)
          if (keyword.relevance === 0) {
            keyword.relevance = 5
          }

          if (!this.set_exists.has(keyword.keyword)) {
            this.keyword_list.push(keyword)
            this.set_exists.add(keyword.keyword)
            this.set_queue.add(keyword.keyword)
          }
        }

        while (this.loading.get_keyword && this.set_queue.size > 0 && !this.is_deleted) {
          const first_of_set = this.set_queue.values().next().value

          const resp_2 = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword/get_keyword', {keyword: first_of_set}, this.cf())
          for (const keyword of resp_2.body.data) {
            keyword.checked = false
            keyword.added = false
            keyword.recommend_price = this.m__calculate(keyword.recommend_price)
            if (keyword.relevance === 0) {
              keyword.relevance = 5
            }

            if (!this.set_exists.has(keyword.keyword)) {
              this.keyword_list.push(keyword)
              this.set_exists.add(keyword.keyword)
              this.set_queue.add(keyword.keyword)
            }

            this.set_queue.delete(first_of_set)
          }

          await this.m__sleep(1000)
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.get_keyword = false
      }
    },

    m__select_top_100_keywords() {
      const length = this.keyword_list.length > 100 ? 100 : this.keyword_list.length
      for (let i = 0; i < length; i++) {
        this.keyword_list[i].checked = true
      }
    },

    m__uncheck_all_keywords() {
      this.keyword_list.forEach(e => e.checked = false)
    },

    m__show_current_keyword() {
      this.fff_tab = 2
      this.fff_tool = true
    },

    m__add_to_recent_keyword(keyword_file) {
      this.keyword_manager.show = false

      for (const item of keyword_file.keyword_json) {
        const selected_item = this.selected_keyword.find(i => i.keyword === item.keyword)
        if (selected_item) {
          Object.assign(selected_item, {...item})
        } else {
          this.selected_keyword.push(item)
        }
      }
    },

    m__initial_save_keyword_file() {
      if (this.selected_keyword.length > 0) {
        this.save_keyword_file.filename = `keywords-${this.selected_keyword[0].keyword} (${this.selected_keyword.length}-${this.$t('base.keyword')} - ${this.$t('base.at')} ${this.timeFormat(new Date())})`
        this.save_keyword_file.show = true
      } else {
        this.ntf_w(this.$t('keyword.empty_to_save'))
      }
    },

    m__try_save_keyword_file() {
      this.confirm(this.$t('keyword.confirm_save_file_x_name', {x: this.save_keyword_file.filename}), () => {
        this.save_keyword_file.loading = true

        this.$http.post(this.API.marketing.keyword_file.add, {
          filename: this.save_keyword_file.filename,
          keyword_json: this.selected_keyword
        }, this.cf())
          .then(async (resp) => {
            this.ntf_s(resp)
            this.$refs['component_keyword_file_manager'].m__get_keyword_file()
            this.save_keyword_file.loading = false
            this.save_keyword_file.show = false
            await this.m__get_keyword_file()
            this.EB.$emit('m__try_save_keyword_file')
          })
          .catch(error => {
            this.ntf_w(error)
            this.save_keyword_file.loading = false
          })
      })
    },

    // TODO: Keyword Tracking
    m__select_all() {
      this.indeterminate = false
      if (this.is_selected_all) {
        this.c__show_keyword_tracking_filter_list.forEach(i => {
          i.checked = true
        })
      } else {
        this.keyword_tracking_list.forEach(i => {
          i.checked = false
        })
      }
    },

    m__indeterminate() {
      if (this.keyword_tracking_list.filter(i => i.checked === true).length === this.keyword_tracking_list.length) {
        this.is_selected_all = true
        this.indeterminate = false
      } else if (this.keyword_tracking_list.filter(i => i.checked === true).length === 0) {
        this.is_selected_all = false
        this.indeterminate = false
      } else {
        this.is_selected_all = false
        this.indeterminate = true
      }
    },

    async m__get_keyword_tracking() {
      this.loading.tracking_get_keyword = true
      try {
        const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/keyword_tracking', {
          ...this.cf(),
          params: {mipeeUserId: this.$store.state.userInfo.username}
        })
        for (const item of resp.data) {
          item.checked = false
          item.loading = false
        }
        this.keyword_tracking_list = resp.data
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.tracking_get_keyword = false
      }
    },

    async m__enter_input_keyword_tracking() {
      if (!this.loading.get_keyword) {
        await this.m__add_keyword_tracking()
      }
    },

    async m__add_keyword_tracking() {
      if (!this.keyword_tracking) {
        return
      }

      if (this.keyword_list.length >= this.limit_keywords) return

      this.loading.tracking_add_keyword = true
      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/keyword_tracking', {
          keywords: [this.keyword_tracking],
          mipeeUserId: this.$store.state.userInfo.username
        }, this.cf())
        await this.m__get_keyword_tracking()
        this.keyword_tracking = ''
        this.ntf_s(this.$t('base.add_keyword_success'))
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.tracking_add_keyword = false
      }
    },

    async m__delete_keyword_tracking(item) {
      try {
        await this.$confirm(this.$t('base.confirm_delete_x', {x: this.$t('base.keyword')}), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        await this.$http.post(this.API.URL_API_SRV_1 + '/keyword_tracking/delete', {
          keywords: [item.keyword],
          mipeeUserId: this.$store.state.userInfo.username
        }, this.cf())
        await this.m__get_keyword_tracking()
        this.keyword_tracking = ''
        this.ntf_s(this.$t('base.add_keyword_success'))
      } catch (e) {

      }
    },

    async m__multiple_delete_keyword_tracking() {
      const keywords = this.c__show_keyword_tracking_filter_list.reduce((result, item) => {
        if (item.checked) {
          result.push(item.keyword)
        }
        return result
      }, [])

      try {
        await this.$confirm(this.$t('base.confirm_delete_x', {x: this.$t('base.keyword')}), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        await this.$http.post(this.API.URL_API_SRV_1 + '/keyword_tracking/delete', {
          keywords,
          mipeeUserId: this.$store.state.userInfo.username
        }, this.cf())
        await this.m__get_keyword_tracking()
        this.keyword_tracking = ''
        this.ntf_s(this.$t('base.add_keyword_success'))
      } catch (e) {

      }
    },

    m__choose_excel_file() {
      this.$el.querySelector(`#input_control`).click()
    },

    async m__import_excel_file(e) {
      try {
        const file_store = e.target.files || e.dataTransfer.files
        if (file_store.length === 0) {
          return
        }

        const keywords = []
        const raw = await readXlsxFile(file_store[0])
        for (const row of raw) {
          if (this.keyword_list.length + keywords.length >= this.limit_keywords) {
            break
          }

          if (row && row[0]) {
            keywords.push(row[0])
          }
        }

        this.loading.tracking_add_keyword = true
        try {
          await this.$http.post(this.API.URL_API_SRV_1 + '/keyword_tracking', {
            keywords,
            mipeeUserId: this.$store.state.userInfo.username
          }, this.cf())
          await this.m__get_keyword_tracking()
          this.keyword_tracking = ''
          this.ntf_s(this.$t('base.add_keyword_success'))
        } catch (e) {
          this.ntf_w(e)
        } finally {
          this.loading.tracking_add_keyword = false
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(this.$t('base.error_reading_file'))
      }
    },

    async m__tracking_download_excel() {
      if (!this.keyword_tracking_list.length) {
        return
      }

      const filename = `keywords-${this.keyword_tracking_list[0].keyword}-${this.dayjs().unix()}.xlsx`
      const data = this.keyword_tracking_list.reduce((result, item) => {
        result.push([item.keyword])
        return result
      }, [])

      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        data,
        filename
      }, {
        ...this.cf(),
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    async m__get_keyword_tracking_volume(item) {
      this.tracking_selected_keyword = item.keyword
      item.loading = true
      try {
        // const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/keyword_tracking/volume', {
        //   ...this.cf(),
        //   params: {keywordTrackingId: item.id}
        // })
        // if (!resp || !resp.data || !resp.data.length || resp.data.length < 50) {
        //   await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword/tracking/generate_data', {keywordTrackingId: item.id}, this.cf())
        //   const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/keyword_tracking/volume', {
        //     ...this.cf(),
        //     params: {keywordTrackingId: item.id}
        //   })
        //   this.keyword_tracking_volume = [...resp.data]
        //   this.chart_tracking_volume = [...resp.data.reverse()]
        // } else {
        //   this.keyword_tracking_volume = [...resp.data]
        //   this.chart_tracking_volume = [...resp.data.reverse()]
        // }
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword/tracking/generate_data', {
          keywordTrackingId: item.id,
          year: this.dayjs().year()
        }, this.cf())
        const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword/tracking/get_data', {keywordTrackingId: item.id}, this.cf())
        this.keyword_tracking_volume = [...resp.body.data]
        this.chart_tracking_volume = [...resp.body.data];
        this.show_dialog.volume = true
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        item.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tool/crawl.vue